import { useContext } from 'react'
import SettingsContext from 'utils/context/SettingsContext'


const useSettings = () => useContext(SettingsContext)

export default useSettings
